import { goTo } from "@client/lib/navigation";
import storage from "@common/lib/storage";
import { isNull } from "lodash";

export type CountdownType = "fixed" | "timer";

export interface CountdownOptions {
  localStorageKey: string;
  date?: Date | string | null;
  type: CountdownType;
  day?: number | string;
  hour?: number;
  minute?: number;
  second?: number;
  redirectUrl?: string | null;
  onExpiry?: () => void;
}

export default (element: HTMLElement, options: CountdownOptions) => {
  if (!element) throw new Error("countdown: element is required");

  let finalDateMS: number | null = null;

  switch (options.type) {
    case "timer": {
      const totalDelay = ((+options.day! * 24 + +options.hour!) * 60 + +options.minute!) * 60 + +options.second!;
      // Check expiration date
      const cachedValue = storage.get(options.localStorageKey);
      const cachedValueExpire = storage.get(`${options.localStorageKey}-expire`);
      if (!!cachedValue && !!cachedValueExpire && +cachedValue === totalDelay) {
        finalDateMS = Number(cachedValueExpire);
      } else {
        const time = new Date().getTime() + totalDelay * 1000;

        storage.set(options.localStorageKey, totalDelay);
        storage.set(`${options.localStorageKey}-expire`, time);

        finalDateMS = time;
      }

      break;
    }
    case "fixed": {
      storage.remove(options.localStorageKey);
      storage.remove(`${options.localStorageKey}-expire`);

      finalDateMS = options.date ? new Date(options.date).getTime() : null;

      break;
    }
    default:
      throw new Error(`Unsupported countdown type: ${options.type}`);
  }

  const $element = $(element);
  $element.countdown(finalDateMS ? new Date(finalDateMS) : new Date(), (event) => {
    $element.html(
      event.strftime(
        '<div class="countdown-container"><div class="countdown-box countdown-days"><div class="number">%-D</div><span>Day%!D</span></div>' +
          '<div class="countdown-box countdown-hours"><div class="number">%H</div><span>Hour%!H</span></div>' +
          '<div class="countdown-box countdown-minutes"><div class="number">%M</div><span>Minute%!M</span></div>' +
          '<div class="countdown-box countdown-seconds"><div class="number">%S</div><span>Second%!S</span></div></div>'
      )
    );

    if (!isNull(finalDateMS)) {
      if (options.onExpiry && finalDateMS <= Date.now()) options.onExpiry();

      if (finalDateMS <= Date.now() && options.redirectUrl) {
        // TODO: remove. goTo should work w/o the timeout.
        setTimeout(() => goTo(options.redirectUrl!), 0);
      }
    }
  });
};
